import { useRecoilState } from "recoil";
import { authAtom } from "state/recoil-root";
import instance from "helpers/instance";
import { totalRow } from "state/roles-permissions";
import { onlinePaymentTransactionAtom } from "state/online-payment-transaction";

const useOnlinePaymentTransactionReport = () => {
  const [auth] = useRecoilState(authAtom);
  const [transactionData, setTransactionData] = useRecoilState(onlinePaymentTransactionAtom);
  const [totalRows, setTotalRows] = useRecoilState(totalRow);

  const headers = {
    Authorization: `Bearer ${auth?.access_token}`,
  };

  function getTransactionReport(filter, page = 0, pageSize = 10) {
    let params = {
      ...filter,
    };
    if (page >= 0 && pageSize > 0) {
      const offset = page * pageSize;
      params = {
        offset,
        limit: pageSize,
        ...filter,
      };
    }

    return instance({
      url: "booking/v1/reports/transactions",
      method: "GET",
      headers,
      params,
    })
      .then((res) => {
        if (res.status === 200) {
          setTransactionData(res.data.data);
          setTotalRows((prevState) => ({
            ...prevState,
            onlinePaymentTransaction: res.data.meta.total,
          }));
          return res.data.data;
        }
      })
      .catch((err) => {
        console.error("Failed to fetch transaction report:", err);
      });
  }

  function exportTransactionReport(filter) {
    const params = {
      ...filter
    };

    headers.responseType = "blob";

    return instance({
      url: "booking/v1/reports/transactions/export",
      method: "GET",
      params,
      responseType: "blob",
      headers,
    });
  }

  return {
    getTransactionReport,
    exportTransactionReport,
  };
};

export { useOnlinePaymentTransactionReport };